import { STATUS_CREATED, STATUS_CREATED_CODE, } from '../constants/constant';
import { ADD_CHILDREN_KEY, EMPTY_CHILDREN_KEY } from "./interface";

interface RowKeyProps {
  mainKey?: string;
  childrenKey?: string;
};
export function formatRowKey(rowKey?: string): RowKeyProps {
  const rowKeys: RowKeyProps = {};
  if (!rowKey) return rowKeys;
  const keyArr = rowKey.split('-');
  rowKeys.mainKey = keyArr[0];
  rowKeys.childrenKey = keyArr[1];
  return rowKeys;
}
export function getEffectiveChildren(childrenData: any) {
  let effectiveChildren: any[] = [];
  if (Array.isArray(childrenData) && childrenData.length) {
    effectiveChildren = childrenData.filter(v => !(v?.[ADD_CHILDREN_KEY] || v?.[EMPTY_CHILDREN_KEY]));
  }
  return effectiveChildren;
}
/**
 * 过滤已删除数据
 * @param dataSource 
 * @param hiddenAddSubRow 
 * @returns 
 */
export function filterDeleteData(
  dataSource?: any[],
  hiddenAddSubRow?: (mainData: any) => boolean,
): any[] {
  const effectiveDataSource: any[] = [];
  if (Array.isArray(dataSource) && dataSource.length) {
    dataSource.forEach(item => {
      if (item[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
        const children = item.children;
        let effectiveChildren: any[] = []
        const hiddenAdd = hiddenAddSubRow ? hiddenAddSubRow(item): false;
        if (Array.isArray(children)) {
          children.forEach(child => {
            if (child[ADD_CHILDREN_KEY]) {
              !hiddenAdd && effectiveChildren.push(child);
              return;
            }
            if (child[STATUS_CREATED_CODE] !== STATUS_CREATED.DELETE) {
              effectiveChildren.push(child);
            }
          });
        }
        effectiveDataSource.push({
          ...item,
          children: effectiveChildren,
        });
      }
    });
  }
  return effectiveDataSource;
}
